export function smoothScrollToTop(element: HTMLElement, duration = 300) {
  const start = element.scrollTop
  const startTime = performance.now()

  function animate(time: number) {
    const progress = Math.min((time - startTime) / duration, 1)
    const eased = 1 - Math.pow(1 - progress, 3) // easeOutCubic

    element.scrollTop = start * (1 - eased)

    if (progress < 1) requestAnimationFrame(animate)
  }

  requestAnimationFrame(animate)
}
